/**
 * Temporary "Overview only" presentation mode for end-user demos.
 *
 * While true, the sidebar shows only Overview (the Reports and
 * Claims & Matters groups are hidden), the header search box is hidden,
 * and the Overview page shows three KPI cards - Potential claims, Changed
 * Events from Disallowed, Changed Events from Allowed - each of which opens
 * its list in a modal over the Overview (same window).
 *
 * Nothing is deleted: the hidden pages and routes are all still in the app
 * (a direct URL still works), so restoring the full app is flipping this
 * one flag to false. This whole mode lives on the `demo/overview-only`
 * branch as a snapshot and is deliberately not on main.
 */
export const OVERVIEW_ONLY = true;

/** Posted by the claims view (inside the modal iframe) to ask the Overview to close the modal. */
export const CLAIMS_MODAL_CLOSE_MESSAGE = "hp-claims-modal-close";

/** Posted by the claims view (inside the modal iframe) after a claim's status changes, so the Overview behind it refetches. */
export const CLAIMS_CHANGED_MESSAGE = "hp-claims-changed";

/**
/** Starter prompts (example questions) in the HP Regulation chat and the HP Genie chat. Hidden; flip to true to show them. */
export const SHOW_STARTER_PROMPTS = false;
